import { FormValues } from "./schema";

function pick<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

function randInt(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function randDate(startMonths: number, endMonths: number): string {
  const now = Date.now();
  const start = now + startMonths * 30 * 86400000;
  const end = now + endMonths * 30 * 86400000;
  return new Date(start + Math.random() * (end - start)).toISOString().slice(0, 10);
}

const projectLabels = [
  "New Office Building", "Phase II Distribution Center", "Medical Office Expansion",
  "Data Center Fit-Out", "Mixed-Use Retail Development", "Warehouse Renovation"
];
const clients = [
  "Acme Development LLC", "Gateway Partners", "Midwest Holdings Corp",
  "Summit Real Estate Group", "Arch Capital Partners", "Heritage Properties"
];
const divisions = ["Denver", "Kansas City", "Phoenix", "Richmond", "St. Louis"];
const projectTypes = ["Office", "Industrial / Warehouse", "Multi-Family", "Healthcare", "Retail", "Mixed-Use"];
const deliveryMethods = ["CM at Risk", "Design-Build", "General Contracting", "CM Fee Only"];

export function generateExampleData(): Partial<FormValues> {
  const contractValue = randInt(5, 80) * 1000000;
  const people = [
    "Mike Johnson", "Sarah Williams", "Tom Brown", "Lisa Davis",
    "Chris Miller", "Pat Wilson", "Alex Taylor"
  ].sort(() => Math.random() - 0.5);

  return {
    projectName: pick(projectLabels),
    jobNumber: `${new Date().getFullYear()}-${String(randInt(1, 999)).padStart(3, "0")}`,
    projectDescription: pick([
      "New 4-story office building with ground-floor retail and structured parking.",
      "Tilt-wall distribution center with 36' clear height and full dock package.",
      "Three-building medical office complex on a 12-acre greenfield site.",
      "Class A multi-family development — 220 units over podium parking."
    ]),
    projectType: pick(projectTypes),
    division: pick(divisions),
    isPreconOnly: pick(["Yes", "No"]),

    preconLead: { displayName: people[0], isFreeform: true } as unknown as string,
    estimator: { displayName: people[1], isFreeform: true } as unknown as string,
    projectExecutive: { displayName: people[2], isFreeform: true } as unknown as string,
    clientName: pick(clients),
    clientContactEmail: `contact${randInt(1, 99)}@client.example.com`,

    bidDueDate: randDate(0, 2),
    constructionStart: randDate(3, 8),
    estimatedContractValue: String(contractValue),
    preconFeeAmount: String(randInt(25, 200) * 1000),
    deliveryMethod: pick(deliveryMethods),
    additionalNotes: pick([
      "",
      "Owner is targeting LEED Silver certification.",
      "Hard bid — no negotiated opportunity.",
      "Phased delivery required; Building A must open by Q4."
    ])
  };
}

// Keep a static export for backward compatibility
export const exampleData = generateExampleData();

